/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

/** @example [{"key":"create","hospitalID":"507f1f77bcf86cd799439011","reservationID":"507f1f77bcf86cd799439011","writerID":{"name":"홍길동","realName":"홍길동","type":1,"jobType":"의사"},"writerType":1,"body":{"isUnregisteredUser":false,"weeklyDays":[3],"userName":"박지호","groupTitle":"도수치료"},"createdAt":"2020-01-01T00:00:00.000Z"}] */
export type V2HReservation = {
  /** create, update, remove 에 대한 값 */
  key?: string;
  /** 병원 ID */
  hospitalID?: string;
  /** 예약 ID */
  reservationID?: string;
  /** 작성자 정보 */
  writerID?: {
    /** 작성자 ID */
    _id?: string;
    /** 작성자 이름 */
    name?: string;
    /** 작성자 실명 */
    realName?: string;
    /** 작성자 유형 */
    type?: number;
    /** 작성자 직업 유형 */
    jobType?: string;
  };
  /** 작성자 유형 */
  writerType?: number;
  /** 예약 내역 본문 */
  body?: Record<string, any>;
  /**
   * 생성 날짜
   * @format date-time
   */
  createdAt?: string;
}[];

export interface ApiV2HreservationElCountParams {
  /** 기준이 되는 예약 _id */
  reservationID?: any;
  /** 병원 ID */
  hospitalID?: any;
  /** 조회할 요소. userName / groupTitle / columnTitle / writerName(modifierName) */
  filterkey?: any;
  /** 수정자 검색 시 검색할 유저 그룹군. 고객 1000, 직원 2000, 애프터닥 3000 */
  "userTypes[]"?: string[];
  /** filterkey 에 대한 검색어 */
  keyword?: any;
}

export type ApiV2HreservationElCountData = ApiResponse & {
  /** 예약 내역 히스토리 카운트 수 */
  data: number;
};

export interface ApiV2HreservationElFindParams {
  /** 기준이 되는 예약 _id */
  reservationID?: any;
  /** 병원 ID */
  hospitalID?: any;
  /** 조회할 요소. userName / groupTitle / columnTitle / writerName(modifierName) */
  filterkey?: any;
  /** 수정자 검색 시 검색할 유저 그룹군. 고객 1000, 직원 2000, 애프터닥 3000 */
  "userTypes[]"?: string[];
  /** filterkey 에 대한 검색어 */
  keyword?: any;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2HreservationElFindData = ApiResponse & {
  data: V2HReservation[];
};

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-H_Reservation
     * @name ApiV2HreservationElCount
     * @summary reservationID 를 통한 예약 객체 히스토리 수 조회
     * @request GET:/v3/api/v2hreservation/el/count
     * @secure
     * @response `200` `ApiV2HreservationElCountData` 예약 객체 히스토리 수 조회 성공
     */
    apiV2HreservationElCount: (query: ApiV2HreservationElCountParams, params: RequestParams = {}) =>
      this.request<ApiV2HreservationElCountData, any>({
        path: `/v3/api/v2hreservation/el/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-H_Reservation
     * @name ApiV2HreservationElFind
     * @summary reservationID 를 통한 예약 객체 히스토리 조회
     * @request GET:/v3/api/v2hreservation/el/find
     * @secure
     * @response `200` `ApiV2HreservationElFindData` 예약 객체 히스토리 조회 성공
     */
    apiV2HreservationElFind: (query: ApiV2HreservationElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2HreservationElFindData, any>({
        path: `/v3/api/v2hreservation/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
